import { render } from "./UploadResourceView.vue?vue&type=template&id=7c979661&scoped=true"
import script from "./UploadResourceView.vue?vue&type=script&lang=js"
export * from "./UploadResourceView.vue?vue&type=script&lang=js"

import "./UploadResourceView.vue?vue&type=style&index=0&id=7c979661&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c979661"]])

export default __exports__